<script setup>

import { ref } from 'vue';
import Header from '../admin/header.vue';
import Form from '../admin/form.vue';

const message = "Please <a href='" + fpe.plugins_page_url + "'>activate the license</a> to use the pro features. Don't have a license? <a href='"+ fpe.pro_upgrade_url +"'>Get one now</a>!";

const is_license_active = ref( fpe.is_license_active );
</script>

<template>
    <Header />
    
    <div class="fpe-pro-upgrade" v-html="message" v-if="!is_license_active"></div>    
    <div class="wpv-fpe-body">
        <Form />
    </div>
</template>